module.exports = __webpack_public_path__ + "media/images/psu-logo-696597fe594b9ee05e58d6e88189ba98.svg";